'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
exports.addOpacityToColor = void 0;
var addOpacityToColor = (exports.addOpacityToColor = function addOpacityToColor(color, opacity) {
	// Check if the hex color is valid
	if (!/^#[0-9A-Fa-f]{6}$/.test(color)) {
		throw new Error('Invalid hex color');
	}

	// Check if the opacity is a valid number between 0 and 1
	if (opacity < 0 || opacity > 1) {
		throw new Error('Invalid opacity value');
	}
	var r = parseInt(color.substring(1, 3), 16);
	var g = parseInt(color.substring(3, 5), 16);
	var b = parseInt(color.substring(5, 7), 16);
	return 'rgba('.concat(r, ', ').concat(g, ', ').concat(b, ', ').concat(opacity, ')');
});
//# sourceMappingURL=colors.js.map
